import { createSlice } from "@reduxjs/toolkit";

import { type TagStateType } from "../interfaces";

const initialState: TagStateType = {
  isLoading: false,
  tags: [],
};

const tagSlice = createSlice({
  name: "tag",
  initialState,
  reducers: {
    setTagLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTags: (state, action) => {
      state.tags = action.payload;
    },
  },
});

export const { setTagLoading, setTags } = tagSlice.actions;
export default tagSlice.reducer;
